import { render, staticRenderFns } from "./PacsStatus.vue?vue&type=template&id=46777720&"
import script from "./PacsStatus.vue?vue&type=script&lang=js&"
export * from "./PacsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports